/**
 * enum for setting block direction, used by setDirection API
 */
// eslint-disable-next-line etc/no-const-enum
export enum CompatibleDirection {

    /**
     * Left to right
     */
    LeftToRight,

    /**
     * Right to left
     */
    RightToLeft,
}
